import React from "react";

/**
 * 
 * @param props 
 */
export const ProfileData = (props) => {




    return (
    <>

        <div className="profileinformation">
            <p><strong>First Name: </strong> {props.graphData.givenName}</p>
            <p><strong>Last Name: </strong> {props.graphData.surname}</p>
            <p><strong>Email: </strong> {props.graphData.userPrincipalName}</p>
            <p><strong>Id: </strong> {props.graphData.id}</p>
            
            </div>
        </>
    );
};